const onScreenInstructions = {
  Mission1: {
    Rookie: [
      "Select each Integrated Circuit on the PCB to zoom in and view its part number.",
      "Open the datasheets provided in your tool menu.",
      "Drag the correct label to the Integrated Circuit: e.g., Microcontroller, Motor Driver, Wireless Transceiver.",
      "Note: Some Integrated Circuits do not have datasheets available.",
    ],
    Intermediate: [
      "Use the multimeter tool to locate JTAG connections (highlight pin headers).",
      "Connect the JTAG debugger to the identified pins.",
      "Enter the memory-read command: read memory 0x000f8900 16384.",
      "Press R for Red and B for Black Probe. TAB for toggle.",
    ],
    Advanced: [
      "Connect up a spectrum analyser to the antenna port on the PCB.",
      "Identify the modulation scheme used by the transceiver as well as its centre frequency, bandwidth, and peak power.",
    ],
  },
  Mission2: {
    Rookie: [
      "Enter passwords using the virtual terminal.",
      "Observe the feedback for each guess:",
      "Green: Correct character in the correct position.",
      "Orange: Correct character in the wrong position.",
      "Red: Incorrect character.",
    ],
    Intermediate: [
      "Complete the provided python script template to iterate through possible passwords.",
      "Use the error feedback system to validate your script and refine it.",
    ],
    Advanced: [
      "Measure response times in milliseconds to determine the correctness of each character.",
    ],
  },
  Mission3: {
    Rookie: [
      "Open the GPS log file to view the data.",
      "Extract the first set of coordinates after the timestamp 00:00:00.",
      "Enter the coordinates into the map’s input fields to pinpoint the location.",
    ],
    Intermediate: [
      "Open the GPS log and command packet file.",
      "If the marker is in the correct location, a message will appear.",
      "Use these values to calculate the missing coordinates.",
    ],
    Advanced: [
      "Open the encrypted packet file and decryption tool.",
      "Use the decryption algorithm to decode the altitude, speed, and bearing values.",
      "Calculate the missing coordinates based on the extracted data.",
    ],
  },
  Mission4: {
    Rookie: [
      "You are presented with a subroutine, get_key(), written in pseudocode. This subroutine takes an initial hardcoded value and creates a numeric key from it. Your task is to work through the logic of the subroutine to calculate the correct key.",
      "Analyse the pseudocode provided, follow the sequence of operations, and derive the numeric key. Use your analytical skills to ensure the key is accurately calculated.",
    ],
    Intermediate: [
      "You are given a subroutine, is_valid_key(), and you are asked to check the provided key's validity.",
    ],
    Advanced: [
      "What key will cause the function ‘CHECK_KEY’ to return with the value 1 in register A?",
    ],
  },
};

export function getInstructionList(missionNumber, levelName) {
  const missionKey = `Mission${missionNumber}`;
  return onScreenInstructions[missionKey]?.[levelName] || [];
}
